import { Adapter } from "../adapters/Adapter";
import { Entity } from "./Entity";
import { LastConnection } from "./LastConnection";

export class Train implements Entity {
	public operationColor: string;
	public operationIcon: string;
	public ustomerId: number;
	public lastConnection = new LastConnection();

	constructor(
		public trainId: number,
		public siteId: number,
		public trainName: string,
		public drivers: string,
		public drivenUnits: string,
		public operation: string,
		public assignedPl: string,
		public assemblyId?: number
	) {
		this.setOperationColor(this.operation);
		this.setOperationIcon(this.operation);
	}

	setOperationColor(operation: string) {
		this.operationColor = "#879baa";
		if (operation) {
			switch (operation.toLowerCase()) {
				case "running":
					this.operationColor = "#27b66d";
					break;
				case "not running":
					this.operationColor = " #e2d000";
					break;
				case "tripped":
					this.operationColor = "#af235f";
					break;
				case "no data":
					this.operationColor = "#F0F0F0";
					break;
				default:
					this.operationColor = "#F0F0F0";
			}
		}
	}

	setOperationIcon(operation: string) {
		this.operationIcon = "help";
		if (operation) {
			switch (operation.toLowerCase()) {
				case "running":
					this.operationIcon = "play";
					break;
				case "not running":
					this.operationIcon = "pause";
					break;
				case "tripped":
					this.operationIcon = "close";
					break;
				case "no data":
					this.operationIcon = "help";
					break;
				default:
					this.operationIcon = "help";
			}
		}
	}

	getId() {
		return this.trainId;
	}

	getType(): "customer" | "site" | "train" {
		return "train";
	}

	getName() {
		return this.trainName;
	}
}

export class TrainAdapter implements Adapter<Train> {
	adapt(item: any): Train {
		return new Train(item.trainId, item.siteId, item.trainName, item.drivers, item.drivenUnits, item.operation, item.assignedPL, item.assemblyId);
	}
}



// WEBPACK FOOTER //
// ./src/app/models/Train.ts